module.exports = __webpack_public_path__ + "static/media/up.36496fa6.svg";